import { useState, useEffect, forwardRef, useContext } from 'react';
import styled from 'styled-components';
import { Collapse } from '@mui/material';
import FaqBg from '../../assets/faq_bg.png';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const FAQ = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const { i18n, t } = useTranslation('en');

    useEffect(() => {
        if(location.hash == "#faq"){
            setOpen(true);
        }
    }, [location.hash]);

    return (
        <div ref={ref} onClick={() => setOpen(!open)}>
            <StyledContainer>
                <StyledHeader>
                    {t("faq.title")} {open ? '-' : '+'}
                </StyledHeader>
                <Collapse in={open}>
                    {
                        i18n.language=="en" ?

                            <div style={{ marginTop: '50px' }}>
                                <StyledTitle>1. What is 開心醫館 (In Good Health)? </StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        We are a one-stop-shop for online Chinese Medicine Telehealth platform. With your mobile phone, you can schedule an appointment with any of the Chinese Medicine Practitioners (“CMPs”) on our platform. Have your video consultation, your prescribed Chinese Medicine will then be delivered to you, and we will manage your digital medical records. 
                                    </StyledP>
                                    <StyledP>
                                        開心醫館 (In Good Health) is a HIPPA compliant telehealth platform that put the Users’ privacy as our highest priority.
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>2. Is 開心醫館 (In Good Health) appropriate for every medical condition?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        No. 開心醫館 (In Good Health) is designed to handle non-emergency, chronic, and low risk medical conditions. It is not intended to replace your primary care Chinese Medicine Practitioner / doctor or to be used in life-threatening emergencies.
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>3. When is 開心醫館 (In Good Health) available?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        開心醫館 (In Good Health) is available 24 hours a day, 7 days a week, and 365 days a year, even on holidays. Walk-in consultations can be made whenever any of the Chinese Medicine Practitioners on the platform is online. One can also schedule appointments with the Chinese Medicine Practitioners on their available time slots. 
                                    </StyledP>
                                </StyledDetail>


                                <StyledTitle>4. Are the practitioners employees of 開心醫館 (In Good Health)?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        開心醫館 (In Good Health) is a technology platform to provide the practitioners with software and connectivity required to offer real-time healthcare services. Practitioners are NOT employees of 開心醫館 (In Good Health). Only CMPs registered with the Hong Kong Chinese Medicine Council are allowed to deliver their healthcare services on our platform.
                                    </StyledP>
                                    <StyledP>
                                        On behalf of the CMPs, 開心醫館 (In Good Health) would collect the fees from users as well as make payments to vendors for providing online healthcare services. 開心醫館 (In Good Health) would charge service fees to the CMPs on transactional basis. 開心醫館 (In Good Health) would have monthly financial settlements with the CMPs.
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>5. Does the practitioners have same responsibilities as in-person care?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        A CMP who substitutes telehealth for traditional modes of delivery of medical care and/or advice remains fully responsible for meeting all legal and ethical requirements and must exercise due diligence when practising telehealth.
                                    </StyledP>
                                    <StyledP>
                                        Standards of care that protect patients during face-to-face medical consultations apply equally to telehealth.
                                    </StyledP>
                                    <StyledP>
                                        If under the CMP’s assessment that the patient’s conditions is inappropriate for telehealth, he/she must immediately cease the telehealth consultation and instruct the patient to seek in-person medical help instead.                               
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>6. What are the most common conditions you treat?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        While telehealth is a good tool to treat different kind of chronic and low risk illnesses, we most often encounter patients with the following illnesses:
                                    </StyledP>
                                    <StyledP>
                                        - Menstrual disorders, Fever, Flu, Cough, Sore throat, Headache, Indigestion,  Diarrhea, Insomnia, Eczema, etc.
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>7. Can payment be made offline?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        No, currently all payments are done online through the STRIPE payment gateway 
                                        (<StyledA 
                                        href="https://stripe.com/en-hk/payments"
                                        onClick={(e) => e.stopPropagation()}
                                        >https://stripe.com/en-hk/payments
                                        </StyledA>). 
                                        It accepts Visa, Mastercard and AE credit card. Payment info is encrypted by the Stripe’s server. 開心醫館 (In Good Health) does not have access to such information.
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>8. Does 開心醫館 (In Good Health) record the video consultations?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        No. 開心醫館 (In Good Health) is simply a platform provider. We do not get involved or have any visibility on any consultation between the Chinese Medicine Practitioner and the User. 
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>9. How long does the medicine delivery takes?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        Our preferred logistic partner is offering the following service:
                                    </StyledP>
                                    <StyledP>
                                        Delivery Model (Mon-Sat, exclude SUN & PH) 
                                        <ul>
                                            <li>Cut-off : 11:00AM</li>
                                            <li>Target same day delivery PM : 18:00-23:00</li>
                                            <li>Target next day delivery AM : 10:00-17:00</li>
                                        </ul>
                                    </StyledP>

                                    
                                    <StyledP>
                                        <i>Note:</i>
                                        <ul>
                                            <li><i>Cut-off is made once dispensary confirmed the prescription order</i></li>
                                            <li><i>Above schedule is for residential addresses delivery. Delivery to commercial and industrial addresses, and remote areas may take extra time</i></li>
                                            <li><i>Delivery time can be affected by bad weather conditions, road blockage, bad traffic, etc.</i></li>
                                            <li><i>We may considering using alternative logistic companies to shorten the delivery time</i></li>
                                        </ul>
                                    </StyledP>

                                    <StyledP>
                                        If a delivery person arrives at your designated address but is somehow unable to make the delivery for any reason, e.g. No one at the designated address to receive the parcel, then another delivery has to be arranged through 開心醫館 (In Good Health)’s customer service. You will be liable to pay a surcharge for the delivery as may be required by our delivery partner.
                                    </StyledP>
                                    
                                    <StyledP>
                                        Note that you can choose to pick up your prescribed Chinese Medicine at the dispensary.  開心醫館 (In Good Health) works with a few dispensaries, therefore the address of self-pick up varies depending on the dispensary chosen by your consulting Chinese Medicine Practitioner.                               
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>10. Why do I have to provide my ID copy?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        User’s ID copy is for the Chinese Medicine Practitioner to verify the identity of the User. 
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>11. Is Telehealth within medical insurance coverage?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        While Telehealth is increasingly being accepted by the insurance industry, please check with your insurance provider for coverage confirmation.
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>12. Do you deliver to remote areas?</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        At the moment, we are unable to cater for remote areas except for <b>Ma Wan</b>, <b>Discovery Bay</b> and <b>Tung Chung</b>. The delivery time for these areas will typically be longer. The exact delivery arrangement will depend upon the courier company to be selected by the dispensary for your prescribed medicine.
                                    </StyledP>

                                    <StyledP>
                                        Samples of remote areas that we cannot deliver to include but not limited to the following: Chek Lap Kok Airport, Cheung Chau, Islands, Lamma Island, Lantau Island, Mui Wo, Ngong Ping, Peng Chau, Pennys Bay and Tai O.
                                    </StyledP>

                                    <StyledP>
                                        When User is inputting the delivery address, only Areas / Districts / Sub Districts within our delivery coverage can be selected.
                                    </StyledP>
                                </StyledDetail>
                            </div>
                            :
                            <div style={{ marginTop: '50px' }}>
                                <StyledTitle>1. 開心醫館是？ </StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        我們是一站式的中醫遠距醫療平台。用戶只需一部智能電話，就能在我們的平台輕鬆預約任何一位中醫師作視像診症。診症之後，用戶就會通過送遞／自取收到該次的處方中藥。用戶的電子病歷也會以安全的方式儲存和管理在我們的平台裏。
                                    </StyledP>
                                    <StyledP>
                                        開心醫館是符合《健康保險流通與責任法案》（HIPAA）的遠距醫療平台，保障用戶的私隱和利益是我們的首要任務。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>2. 開心醫館是否適合治療各種醫療狀況？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        不是。開心醫館主要用於處理非緊急，慢性和低風險的中等疾病。並不能百分百替代您的家庭醫生／中醫師，也絕不建議用於生命受威脅的緊急情況。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>3. 開心醫館的服務時間是？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        開心醫館是全天候營業、提供服務並且全年無休。只要平台上任何一位中醫師顯示為「在線」，用戶都可即時輪候作視像診症，亦可根據中醫師自定的診症時間作預約。 
                                    </StyledP>
                                </StyledDetail>


                                <StyledTitle>4. 平台上的中醫師是開心醫館的員工嗎？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        開心醫館只是一個電子平台，為中醫師提供實時醫療視像診症服務所需的軟件連接和設備，平台上的中醫師並不是開心醫館的員工。只有在香港中醫藥管理局註冊的中醫師才可以在我們的平台上為用戶提供醫療服務。
                                    </StyledP>
                                    <StyledP>
                                        另外，開心醫館將代表中醫師向用戶收取費用，並向有關的醫療保健服務供應商付款。 開心醫館會在用戶的應付金額中扣除服務費，並將每月與中醫師進行財務結算。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>5. 中醫師在遠距診症中是否有與當面診症的相同責任？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        中醫師進行遠距醫療診症代替傳統的當面診症和/或任何醫療服務方式時仍須遵守香港註冊中醫專業守則或表列中醫守則和滿足所有法律和道德要求，並且在遠距醫療診症中盡職盡責。
                                    </StyledP>
                                    <StyledP>
                                        當面診症期間對保障用戶的醫療利益標準同樣適用於遠距醫療診症。
                                    </StyledP>
                                    <StyledP>
                                        如根據中醫師的評估，用戶當刻的狀況不適合進行遠距醫療診症，中醫師必須立即終止診症，並指示用戶尋求當面醫療協助或轉介就診。 
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>6. 在平台上通常治療的最常見疾病是甚麼？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        遠距醫療平台是治療各種慢性和低風險疾病的好工具，而我們最常遇到的疾病有以下：月經失調、發燒、流感、咳嗽、咽喉炎、頭痛、消化不良、腹瀉、失眠、濕疹等等。                           
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>7. 診金可以線下支付嗎？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        不可以。目前所有付款都只能通過STRIPE付款平台在線完成（
                                        <StyledA 
                                        href="https://stripe.com/zh-cn-hk"
                                        onClick={(e) => e.stopPropagation()}
                                        >https://stripe.com/zh-cn-hk/payments
                                        </StyledA>）。STRIPE是一個網絡收付款平台，接受 Visa、Mastercard 或 AE 信用卡付款。付款資料經由STRIPE的服務器加密，開心醫館無權查閱。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>8. 開心醫館會錄製和儲存視像診症嗎？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        不會，開心醫館是一個遠距醫療平台供應商。我們絕不會介入、擷取、錄製和儲存用戶和中醫師之間視像診症的任何內容。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>9. 藥物的派送時間需要多久？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        我們的物流合作夥伴將提供以下服務：
                                    </StyledP>
                                    <StyledP>
                                        運輸時間（週一至週六，不包括星期日和公眾假期）
                                        <ul>
                                            <li>截單收貨時間：上午11時正</li>
                                            <li>即日配送到家（下午）：下午6時至11時正</li>
                                            <li>次日配送到家（上午）：上午10時至下午5時正</li>
                                        </ul>
                                    </StyledP>

                                    <StyledP>
                                        備註：
                                        <ul>
                                            <li><i>截單時間是指藥房正式確認處方訂單</i></li>
                                            <li><i>以上時間表只適用於住宅地址，運送到商業和工商地址以及偏遠地區可能需要更多時間</i></li>
                                            <li><i>送貨服務時間可能會受到惡劣天氣情況，道路阻塞或交通事故等影響</i></li>
                                            <li><i>我們可能會考慮使用其他物流公司來縮短送貨時間</i></li>
                                        </ul>
                                    </StyledP>

                                    <StyledP>
                                        如果運送員於運送時間到達用戶指定的地址，但由於任何原因而無法以某種方式送達：例如沒有人在指定地址接收藥物。此時用戶就必須通過開心醫館的客戶服務安排另一次的運送。用戶將有責任按照我們的物流合作夥伴的要求為該次送遞支付額外費用。
                                    </StyledP>

                                    <StyledP>
                                        另外，開心醫館亦與數個香港藥房合作。用戶可以根據中醫師所選擇的藥房，選擇自行到藥房領取中藥。             
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>10. 為什麼用戶需要登記身份證明文件？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        這是供中醫師核實用戶身份之用。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>11. 視像診症服務會涵蓋在保險保障範圍內嗎？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        雖然遠距醫療行業已逐漸被保險業界接受和認可，但請根據已投保的保險服務提供者所提供的保險計劃的受保範圍作出查詢。
                                    </StyledP>
                                </StyledDetail>

                                <StyledTitle>12. 送遞藥物設有地區服務限制嗎？</StyledTitle>
                                <StyledDetail>
                                    <StyledP>
                                        目前，除了<b>馬灣</b>、<b>愉景灣</b>和<b>東涌</b>以外，我們無法提供偏遠地區送遞服務。而以上地區的送遞時間將會較長，確實的送遞安排將取決於藥房為您的處方藥而選擇的快遞公司。
                                    </StyledP>    
                                    <StyledP>
                                        送遞服務暫時不適用於以下地區：赤臘角、長洲、離島、南丫島、大嶼山、梅窩、昂坪、坪洲、竹篙灣、大澳。
                                    </StyledP>
                                    <StyledP>
                                        當用戶輸入收貨地址時，只能選擇我們所覆蓋範圍內的地區／子地區／地點。
                                    </StyledP>
                                </StyledDetail>
                            </div>
                    }
                </Collapse>
            </StyledContainer>
        </div>
    );
});

const StyledContainer = styled.div`
  /* border: 1px solid red; */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  color: white;
  padding: 0 10%;
  background: url(${FaqBg}) no-repeat center center / cover;;
  padding: 50px 10%;
`;

const StyledHeader = styled.div`
  /* border: 1px solid blue; */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  /* font-family: SF Pro Display; */
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: 42px;
`;


const StyledTitle = styled.div`
  /* border: 1px solid blue; */
  color: white;
  /* font-family: SF Pro Display; */
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 10px;
`;

const StyledDetail = styled.div`
    margin-bottom: 50px;
    color: #F3F3F3;
`;

const StyledP = styled.p`
  /* border: 1px solid blue; */
  color: white;
  /* font-family: SF Pro Display; */
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

const StyledA = styled.a`
  /* border: 1px solid blue; */
  color: #324492;
  /* font-family: SF Pro Display; */
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

export default FAQ;
